import React from 'react';
import { Controller, ControllerProps } from 'react-hook-form';
import { TextFieldProps } from '@mui/material';

import { ContentRich } from '../Posts/Forms';
import TextFieldDefault from '../Posts/Forms/TextFieldDefault';

/**
 * A controlled form component used with react-hook-form.
 * @param control the form control created by react-hook-form (useForm)
 * @param defaultValue the default value related to this controlled form input
 */

type ControlledTextFieldProps = TextFieldProps & {
  control: any;
  name: string;
  defaultValue?: string;
  richText?: boolean;
  component?: any;
  componentProps?: any;
  editingOptions?: string[];
  maxLength?: number;
  rules?: ControllerProps['rules'];
  numbersOnly?: boolean;
};

function ControlledTextField({
  control,
  rules,
  name,
  defaultValue = '',
  richText = false,
  numbersOnly = false,
  component,
  componentProps = {},
  ...rest
}: ControlledTextFieldProps) {
  const Comp = component || (richText ? ContentRich : TextFieldDefault);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue || ''}
      render={({ field: { onChange, ...fieldProps } }) => {
        const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = event.target.value;

          // allow only numbers
          if (value.match(/^-?\d*\.?\d*$/)) {
            onChange?.(event);
          }
        };

        return (
          <Comp
            onChange={numbersOnly ? handleNumberChange : onChange}
            {...fieldProps}
            id={name}
            name={name}
            {...rest}
            {...componentProps}
          />
        );
      }}
    />
  );
}

export default ControlledTextField;
